export class EmailHelper {
  public static readonly HP_DOMAIN = 'hp.com'

  public static normalize(email: string): string {
    return email.trim().toLowerCase()
  }

  public static isSame(a: string, b: string): boolean {
    return EmailHelper.normalize(a) === EmailHelper.normalize(b)
  }

  public static isHPDomain(email: string): boolean {
    return EmailHelper.normalize(email).endsWith(EmailHelper.HP_DOMAIN)
  }
}
